export default __webpack_public_path__ + "x-icon.a68989de.svg";